const personal = {
  // page.tsx / JSON-LD
  'personal.jsonld.serviceName': '執事養成課程｜通学型 個人向けコース',
  'personal.jsonld.orgName': '一般社団法人全日本執事協会',
  'personal.jsonld.serviceType': '執事養成教育',
  'personal.jsonld.areaServed': '日本',
  'personal.jsonld.description': '東京・お台場の本校に通学し、執事の所作を基礎から体系的に学ぶ個人向けの執事養成課程。土日開催・完全少人数制（定員6名）で、エッセンシャル・アドバンス・マスターの3コースを提供する日本の執事学校です。',
  'personal.jsonld.breadcrumb1': 'ホーム',
  'personal.jsonld.breadcrumb2': '個人のお客様',

  // HeroSection (lead)
  'personal.hero.homeLink': 'ホーム',
  'personal.hero.currentPage': '個人のお客様',
  'personal.hero.title': 'お台場の校舎で学ぶ、通学型の執事養成',
  'personal.hero.titleEn': 'FOR INDIVIDUALS — CAMPUS-BASED TRAINING',
  'personal.hero.lead': '日本執事アカデミーの個人向けコースは、東京・お台場の本校に通学し、執事の所作を基礎から体系的に学ぶ教育プログラムです。土日開催・完全少人数制（定員6名）で、未経験からでも無理なく学べます。東京・お台場の執事学校として、通学型の個人受講で基礎から丁寧に身につけられます。',
  'personal.hero.imgAlt': '日本執事アカデミーのお台場本校で執事の所作を学ぶ受講生',
  'personal.hero.badge1': '土日通学・完全少人数制（定員6名）',
  'personal.hero.badge2': 'エッセンシャル／アドバンス／マスターの3コース',
  'personal.hero.badge3': '修了時に協会認定資格を授与',

  // CTA row at bottom
  'personal.cta.corporateNote': '法人・団体でのご検討はこちら',
  'personal.cta.corporateLink': '法人のお客様（出張型研修）',
};

export default personal;
